import { Check, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { memo, useState, useMemo, useEffect } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import AccordionSubscriptionCohabitationDataForm from './form';
import { CommonInterfaceSubscription } from 'subscription/view-models/common-interface-subscription';
import Close from '@mui/icons-material/Close';
import { AccordionFamilyCoexistence } from 'shell/view-models/accordion-family-coexistence';

interface AccordionSubscriptionCohabitationDataProps {
  disabled?: boolean;
  isCohabitation?: boolean;
  withoutFamily?: boolean;
}

const AccordionSubscriptionCohabitationDataComponent = ({
  disabled = false,
  isCohabitation = false,
  withoutFamily = false,
}: AccordionSubscriptionCohabitationDataProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CommonInterfaceSubscription>();

  useEffect(() => {
    onFieldsAccordionSubscriptionCohabitationDataChange({
      bondDate: formContext.values.generality?.birthDate,
      membershipDate: formContext.values.generality?.birthDate,
    });
  }, [formContext.values.generality?.birthDate]);

  const onFieldAccordionSubscriptionCohabitationDataChange = useEventCallback(
    (
      key: keyof AccordionFamilyCoexistence,
      value: AccordionFamilyCoexistence[keyof AccordionFamilyCoexistence]
    ) => {
      formContext.setFieldValue('familyCoexistence', {
        ...(formContext.values.familyCoexistence || {}),
        [key]: value,
      });
    }
  );

  const onFieldsAccordionSubscriptionCohabitationDataChange = useEventCallback(
    (values: AccordionFamilyCoexistence) => {
      formContext.setFieldValue('familyCoexistence', {
        ...(formContext.values.familyCoexistence || {}),
        ...values,
      });
    }
  );

  const errorFamily = useMemo(() => {
    return !!formContext.errors.familyCoexistence;
  }, [formContext.errors.familyCoexistence]);

  const resetForm = useEventCallback(() => {
    // reset solo dei campi editabili
    formContext.setFieldValue('familyCoexistence', {
      ...(formContext.values.familyCoexistence || {}),
      membershipDate: null,
      bondDate: null,
      relationship: null,
      coexistenceBond: null,
      progComponent: undefined,
    });
  });

  return withoutFamily ? (
    <></>
  ) : (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-family-coexistence-content"
        id="panel-person-family-coexistence-contentheader"
        expandIcon={<ExpandMore />}
      >
        {errorFamily ? <Close color="error" /> : <Check color="success" />}
        <Typography>Dati iscrizione in convivenza</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <AccordionSubscriptionCohabitationDataForm
          disabled={disabled}
          values={formContext.values.familyCoexistence}
          onChange={onFieldAccordionSubscriptionCohabitationDataChange}
          resetForm={resetForm}
          isCohabitation={isCohabitation}
          errors={formContext.errors.familyCoexistence as FormikErrors<AccordionFamilyCoexistence>}
          touched={
            formContext.touched
              .familyCoexistence as unknown as FormikTouched<AccordionFamilyCoexistence>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionSubscriptionCohabitationDataComponent.displayName =
  'Accordion Cohabitation Data subscription component';

const AccordionSubscriptionCohabitationData = memo(AccordionSubscriptionCohabitationDataComponent);

export default AccordionSubscriptionCohabitationData;
